export default {
    emailSettings: {
        emailUserId: '',
    },
    smsSettings: {

    }
}